import { Theme } from '@mui/material';

export default function AppBar(theme: Theme) {
  return {
    MuiAppBar: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.default,
          borderBottom: `1px solid ${ theme.palette.grey[300] }`,
          padding: '1rem 0 .625rem 0',
        },
      },
    },
  };
}
